// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__ZT-o1","footer":"ModalFilter_footer__3BBIh"};